import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/entries/$entryId',
}).lazy(() => import('./entries.$entryId.index.lazy').then((d) => d.Route))
